import axios from 'axios';


const state = {
  
};

const getters = {
    
};

const actions = {
  statusCheckLogin(){
    return axios.post('/login/', {
        username: 'FakeUser@email.com',
        password: 'fakepasswordgoeshere'
    })
    .catch(error => {
        if(!error.response){
          return false;
        } else {
          return true;
        }
    });
  },
  
  docxAPIStatus(){
    return axios.get('/docxApiStatus/')
    .then(res => {
        let obj = {};
        obj['docx'] = res.data.docx;
        return obj;
        
    }).catch(error => {
        if(!error.response){
          let obj = {};
          obj['docx'] = "N/A";
          obj['middle'] = false;
          return obj;
        }
      }
    );
  },
};

const mutations = {
    
};

export default {
    state,
    getters,
    actions,
    mutations
};